import React from 'react'
import { render } from 'react-dom'

export const mountOnId = (component, domId) => {
  const domNode = document.getElementById(domId)
  if (domNode) {
    const newElement = React.createElement(component, domNode.dataset)
    render(newElement, domNode)
  }
}
